module.exports = __webpack_public_path__ + "img/lior.bc922a84.png";